export default {
      id: "ic_live-usage",
      viewBox: "0 0 15 11",
      url: "/" + "images/icons.3.109.2.svg#ic_live-usage",
      toString: function () {
        return this.url;
      }
    }